import styled from 'styled-components/macro';
import images from '~/constants/images';

export const StaticContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.light};
  height: auto;
  overflow-y: scroll;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    padding: 30px;

    &:before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.05;
      background-image: url(${images.beat});
      background-repeat: no-repeat;
      background-position: center 110%;
      z-index: 0;
    }
  }
`;

export const Logo = styled.div`
  width: ${({ logoWidth }) => logoWidth || '100%'};
  height: ${({ logoHeight }) => logoHeight || 'auto'};
  background-image: url(${({ src }) => src && src});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;
`;

export const Title = styled.p`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme }) => theme.blue};
  width: 100%;
  text-align: center;
  margin: 20px 0 10px;
`;

export const SubTitle = styled.p`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h4}px;
  color: ${({ theme }) => theme.black};
  width: 100%;
  text-align: center;
  margin: 0 0 10px;
  text-transform: uppercase;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  p {
    font-family: ${({ theme }) => theme.primaryFontLight};
    width: 100%;
    text-align: left;
    margin: 20px 0;

    b {
      font-family: ${({ theme }) => theme.primaryFontMedium};
    }

    a {
      text-decoration: underline;
    }
  }
`;

export const Close = styled.a`
  width: auto;
  height: auto;
  padding: 10px 40px;
  background-color: ${({ theme }) => theme.blue};
  color: ${({ theme }) => theme.white};
  cursor: pointer;
  z-index: 50;
`;

export const Wrapper = styled.div`
  padding: 40px 75px;
`;
